import { useCallback } from "react";
import { useAppDispatch } from "./redux";
import { getReportAsyncThunk } from "../../redux/features/report/reportAsyncThunk";

export const useFetchReport = () => {
    const dispatch = useAppDispatch();

    return useCallback(async (id: string) => {
        if (id) {
            await dispatch(getReportAsyncThunk({ id, withDeleted: true }));
        }
    }, [dispatch]);
};